module.exports = __webpack_public_path__ + "static/media/variable1.561b0ec6.jpg";